module.exports = __webpack_public_path__ + "img/pk.471b4667.svg";